import React, { FC }         from 'react';
import {
  Grid,
  Box,
  CircularProgress,
}                            from '@material-ui/core';
import { makeStyles }        from '@material-ui/core/styles';
import { TDataTableRow }     from '@typings/components';
import { EStatsType }        from '@enums/dashboard';
import { STATS_TABLE_TITLE } from '@modules/dashboard/utils/suggestions';
import {
  TOTAL_INNER_STATS_HEADERS,
  TOTAL_INNER_STATS_SUBHEADERS,
  MONTH_INNER_STATS_HEADERS,
  MONTH_INNER_STATS_SUBHEADERS,
  SERVICE_STATS_HEADERS,
  SERVICE_STATS_SUBHEADERS,
}                            from '@modules/dashboard/utils/tableHeaders';
import { StatisticsTable }   from '@modules/dashboard/components/StatisticsTable';

const useStyles = makeStyles({
  progressWrapper: {
    display        : 'flex',
    justifyContent : 'center',
    alignItems     : 'center',
    height         : 500,
  },
});

interface IProps {
  isLoadingStats               : boolean;
  servicesStatisticsRows       : TDataTableRow[];
  innerMonthStatisticsRows     : TDataTableRow[];
  innerTotalStatisticsRows     : TDataTableRow[];
  isServiceStatsExpanded       : boolean;
  isInnerStatsExpanded         : boolean;
  toggleIsServiceStatsExpanded : () => void;
  toggleIsInnerStatsExpanded   : () => void;
  downloadServicesExcel        : () => Promise<void>;
  downloadInnerMonthExcel      : () => Promise<void>;
  downloadInnerTotalExcel      : () => Promise<void>;
  onVinHistoryLinkClick?       : () => void;
}

export const StatisticsBlock: FC<IProps> = ({
  isLoadingStats,
  servicesStatisticsRows,
  innerMonthStatisticsRows,
  innerTotalStatisticsRows,
  isServiceStatsExpanded,
  isInnerStatsExpanded,
  toggleIsServiceStatsExpanded,
  toggleIsInnerStatsExpanded,
  downloadServicesExcel,
  downloadInnerMonthExcel,
  downloadInnerTotalExcel,
  onVinHistoryLinkClick,
}) => {
  const { progressWrapper } = useStyles();

  return (
    <Grid
      spacing    = {5}
      justify    = "center"
      alignItems = "center"
      container
    >
      {isLoadingStats ? (
        <Box className={progressWrapper}>
          <CircularProgress color="secondary" />
        </Box>
      ) : (
        <>
          <Grid item xs={12}>
            <StatisticsTable
              tableTitle    = {STATS_TABLE_TITLE[EStatsType.InnerTotal]}
              headers       = {TOTAL_INNER_STATS_HEADERS}
              subHeaders    = {TOTAL_INNER_STATS_SUBHEADERS}
              tableNoteText = "Note: When filtering by CU, the count of Active Users does not change."
              rows          = {innerTotalStatisticsRows}
              downloadExcel = {downloadInnerTotalExcel}
              onLinkClick   = {onVinHistoryLinkClick}
            />
          </Grid>

          <Grid item xs={12}>
            <StatisticsTable
              tableTitle            = {STATS_TABLE_TITLE[EStatsType.InnerMonthly]}
              headers               = {MONTH_INNER_STATS_HEADERS}
              subHeaders            = {MONTH_INNER_STATS_SUBHEADERS}
              tableNoteText         = "Note: The Amount of current month is estimated."
              rows                  = {innerMonthStatisticsRows}
              isTableExpanded       = {isInnerStatsExpanded}
              toggleIsTableExpanded = {toggleIsInnerStatsExpanded}
              downloadExcel         = {downloadInnerMonthExcel}
              withPeriodCell
            />
          </Grid>

          <Grid item xs={12}>
            <StatisticsTable
              tableTitle            = {STATS_TABLE_TITLE[EStatsType.Services]}
              headers               = {SERVICE_STATS_HEADERS}
              subHeaders            = {SERVICE_STATS_SUBHEADERS}
              rows                  = {servicesStatisticsRows}
              isTableExpanded       = {isServiceStatsExpanded}
              toggleIsTableExpanded = {toggleIsServiceStatsExpanded}
              downloadExcel         = {downloadServicesExcel}
              withPeriodCell
            />
          </Grid>
        </>
      )}
    </Grid>
  );
};
